import axios from 'axios';
import reduxStore from '../store';

let API_URL;
if (location.hostname == 'manager.eshipi.com') {
    API_URL = "https://api.eshipi.com/api"
} else if(location.hostname == 'eshipi.speedliv.com') {
    API_URL = "https://api-eshipiv2.speedliv.com/api";
}else{
    API_URL = "http://" + location.hostname + ":3021/api";
    //API_URL = "http://167.71.1.17:3021/api";
}

const token = window.localStorage.getItem("id_token");

const HTTP = axios.create({
    baseURL: API_URL,
    headers: {
        'X-Auth-Token': token
    }
})

HTTP.interceptors.response.use(function (response) {
    // Do something with response data
    if(response.data && response.data.status == 401 && token){
        window.localStorage.removeItem('id_token');
        window.location.href = '/';
    }else if(response.data && response.data.status == 400 && token){
       alert(response.data.content)
    }else{
        // const fe_version = response.headers['pragma'] || 'default'
        // if(token && response.config && response.config.method == 'get' && fe_version !== localStorage.getItem('pr-version')){
        //     reduxStore.dispatch("actionupdate",{update:true,pr_version:fe_version});
        // }
        const fe_headers = response.headers;
        if(token && response.data && response.data.content && response.config && response.config.method && fe_headers && reduxStore.state && reduxStore.state.user && reduxStore.state.user.email){
            const fe_version = fe_headers['pragma'] || '1';
            if(fe_headers['cache-control']){
                var properties = fe_headers['cache-control'].split(',');
                var myobjData = {};
                if( typeof properties === 'object'){
                    properties.forEach(function(property) {
                        var tup = property.split(':');
                        myobjData[tup[0]] = tup[1];
                    });
                }
                if(myobjData && myobjData.Notifs && parseInt(myobjData.Notifs)>0 && myobjData.userId && myobjData.userId.toString() ===  reduxStore.state.user._id.toString() || (fe_version !== localStorage.getItem('pr-version'))){
                    reduxStore.dispatch("actionupdate",{update_version:'ok',pr_version:fe_version,NewNotifs:parseInt(myobjData.Notifs)});
                }
            }
        }
     

        return response;
    }
  }, function (error) {
    // Do something with response error
    return Promise.reject(error);
  });

export default HTTP
